export default __webpack_public_path__ + "static/media/points-redemption-failed.dbd77182.svg";